import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import Select from 'react-select';

export const Container = styled.div`
  width: 440px;
  background-color: ${themeGet('colors.white')};
  border: 1px solid ${themeGet('colors.black.10')};
  border-radius: 8px;
  margin: 0 0 16px;
  font-family: 'Montserrat', sans-serif;
`;

export const Title = styled.h3`
  color: ${themeGet('colors.black.80')};
  margin: 0;
  font-size: 14px;
  font-weight: 500;
`;

export const TitleLearnMoreWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 8px 24px 1px;
`;

export const LearnMoreLink = styled.a`
  color: ${themeGet('colors.primary.100')};
  font-size: 12px;
  font-weight: 600;
`;

export const ScheduledMessage = styled.p`
  font-size: 12px;
  line-height: 22px;
  font-weight: 400;
  color: ${themeGet('colors.black.80')};
  margin: 0 24px 8px 24px;
`;

export const SelectWrapper = styled.div`
  margin: 24px 24px 0 24px;
`;

export const SelectLabel = styled.p`
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 9px;
  margin-top: 0px;
  color: ${themeGet('colors.black.80')};
`;

export const StyledSelect = styled(Select)`
  .react-select__control {
    font-weight: 500;
    font-size: 14px;
    border-radius: 8px;
    border: 1px solid ${themeGet('colors.black.20')};
  }
  .react-select__indicator {
    color: ${themeGet('colors.black.80')};
  }
  .react-select__value-container {
    height: 40px;
  }
  .react-select__single-value {
    color: ${themeGet('colors.black.100')};
  }
  .react-select__menu {
    font-size: 14px;
  }
  .react-select__input {
    input {
      margin-bottom: 0 !important;
    }
  }
`;

export const SwitchWrapper = styled.div`
  margin: 24px;
  display: flex;
  justify-content: space-between;
`;

export const Label = styled.p`
  font-size: 14px;
  font-weight: 400;
  margin: 0;
  color: ${themeGet('colors.black.80')};
`;

export const CheckboxContainer = styled.div`
  margin-left: 24px;
`;

export const CheckboxWrapper = styled.div`
  margin-top: 16px;
  display: flex;
  align-items: center;
`;

export const Checkbox = styled.input`
  height: 20px;
  width: 20px;
`;

export const CheckboxLabel = styled.label`
  font-size: 14px;
  margin: 0 0 0 10px;
  font-weight: 500;
  color: ${themeGet('colors.black.100')};
`;

export const ButtonContainer = styled.div`
  margin: 16px 0px 16px 12px;
`;
